<template>
	<div>
		<div v-if="!isLoading">
			<vs-table
				:data="keywords"
				max-items="100"
				pagination
				search
				ref="ref-keywords-ideas-table"
				class="mt-5"
				noDataText="Aucun(e) mots-clés."
			>
				<template slot="thead">
					<vs-th style="pointer-events: auto" sort-key="keyword"
						>Mots-clés</vs-th
					>
					<!-- Madame ou Monsieur -->
					<vs-th style="pointer-events: auto" sort-key="cpc">CPC</vs-th>
					<vs-th style="pointer-events: auto" sort-key="cpc">Volume</vs-th>
				</template>
				<template slot-scope="{ data }">
					<vs-tr
						:data="data[indextr]"
						:key="indextr"
						v-for="(tr, indextr) in data"
					>
						<vs-td :data="data[indextr].keyword"
							><vs-input v-model="tr.keyword"></vs-input
						></vs-td>
						<vs-td :data="data[indextr].cpc" class="text-right"
							><vs-input v-model="tr.cpc"></vs-input>
							<!-- {{
							!isNaN(tr.cpc)
								? convertInternationalNumberToFrenchCurrency(tr.cpc)
								: tr.cpc
						}} -->
						</vs-td>
						<vs-td :data="data[indextr].search_volume" class="text-right">
							<vs-input v-model="tr.search_volume"></vs-input>
							<!-- {{ tr.search_volume.toLocaleString("fr-FR") }} -->
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
			<div class="flex justify-end mt-4">
				<vs-button color="success" @click="updateKeywords()"
					>Mettre à jour</vs-button
				>
			</div>
		</div>
		<circular-loader v-else />
	</div>
</template>

<script>
import utilsMixin from "../../../mixins/utilsMixin";
import dbFieldConvertorMixin from "../../../mixins/dbFieldConvertorMixin";
import ProspectSearch from "../../../entities/ProspectSearch";
import CircularLoader from "../../../components/widgets/loader/CircularLoader.vue";

export default {
	components: { CircularLoader },
	name: "UpdateKeywordsPage",
	props: {
		projectId: {
			type: Number,
			default: 0,
		},
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	// Your component's logic goes here
	data() {
		return {
			keywords: [],
			oldKeywords: [],
			isLoading: false,
			// mainUrl: null,
		};
	},
	watch: {},
	computed: {
		// Your component's computed properties go here
		// newProspects() {
		// 	return store.state.newProspects;
		// },
	},
	created() {
		this.getKeywordsByProjectId();
	},
	updated() {},
	methods: {
		getKeywordsByProjectId() {
			this.isLoading = true;
			ProspectSearch.getKeywordsByProjectId(this.projectId)
				.then((response) => {
					this.keywords = response;
					this.oldKeywords = JSON.parse(JSON.stringify(response));
				})
				.finally(() => {
					this.isLoading = false;
				});
		},
		/**check updated list */
		getChangedObjects(oldData, newData) {
			const sortedOld = [...oldData].sort((a, b) => a.id - b.id);
			const sortedNew = [...newData].sort((a, b) => a.id - b.id);

			return sortedNew.filter((newItem) => {
				const oldItem = sortedOld.find((item) => item.id === newItem.id);

				if (!oldItem) return true; // New item

				return (
					oldItem.project_id !== newItem.project_id ||
					oldItem.keyword !== newItem.keyword ||
					oldItem.cpc !== newItem.cpc ||
					oldItem.search_volume !== newItem.search_volume
				);
			});
		},
		updateKeywords() {
			const changedKeywords = this.getChangedObjects(
				this.oldKeywords,
				this.keywords
			);
			if (changedKeywords.length === 0) {
				this.$vs.notify({
					title: "Aucun changement",
					text: "Aucun changement n'a été détecté.",
					color: "warning",
				});
				return;
			} else {
				ProspectSearch.updateKeywords(changedKeywords)
					.then((response) => {
						this.$vs.notify({
							title: "Succès",
							text: "Les mots-clés ont été mis à jour avec succès.",
							color: "success",
							time: 1000,
						});
						this.getKeywordsByProjectId();
					})
					.catch((error) => {
						this.$vs.notify({
							title: "Echec",
							text: "Une erreur s'est produite lors de la mise à jour des mots-clés.",
							color: "danger",
						});
					});
			}
		},
	},
};
</script>

<style scoped>
</style>